import { SECTIONS } from "@/data/workbook";

// Count trackable items and completed items for a section's stored data.
function sectionStats(section, sdata, photoCount) {
  let total = 0;
  let done = 0;
  for (const block of section.blocks) {
    const bd = sdata?.[block.key] || {};
    if (block.type === "checklist") {
      total += block.items.length;
      done += block.items.filter((it) => bd[it.k]).length;
    } else if (block.type === "wmc") {
      total += block.items.length;
      done += block.items.filter((it) => bd[it.k] && (bd[it.k].w || bd[it.k].m || bd[it.k].c)).length;
    } else if (block.type === "fields") {
      total += block.fields.length;
      done += block.fields.filter((f) => bd[f.k] !== undefined && bd[f.k] !== "").length;
    } else if (block.type === "measurements") {
      total += block.rows.length;
      done += block.rows.filter((r) => bd[r.k]?.value).length;
    } else if (block.type === "table") {
      total += 1;
      const rows = Array.isArray(bd) ? bd : bd.rows;
      if (Array.isArray(rows) && rows.length > 0) done += 1;
    } else if (block.type === "textarea") {
      total += 1;
      if (bd && typeof bd === "string" && bd.trim()) done += 1;
    } else if (block.type === "photoRegister") {
      total += 1;
      if (photoCount > 0) done += 1;
    }
  }
  return { total, done };
}

export function sectionProgress(section, data, photoCount = 0) {
  const { total, done } = sectionStats(section, data?.[section.id], photoCount);
  return total === 0 ? 0 : Math.round((done / total) * 100);
}

export function overallProgress(data, photoCount = 0) {
  let total = 0;
  let done = 0;
  for (const s of SECTIONS) {
    const stat = sectionStats(s, data?.[s.id], photoCount);
    total += stat.total;
    done += stat.done;
  }
  return total === 0 ? 0 : Math.round((done / total) * 100);
}
